/**
 * created by wang lei
 向下合并单元格 页面
 *
 */
import React, {Component} from 'react';
import mergeDown from './mergeDown.png';
import {EDITOR_TOOL_BTN_COLOR} from "../../../../../constants";

export default class MergeDownTool extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mergeDown:false
        }
    }
    /**
     * 监听内容变化
     */
    listenContentChange(){
        let mergeDown = this.props.editor.queryCommandState("mergedown")
        this.setState({mergeDown: mergeDown === 0});
    }

    /**
     * 监听编辑器点
     */
    listenContentClick(){
        let mergeDown = this.props.editor.queryCommandState("mergedown")
        this.setState({mergeDown: mergeDown === 0});
    }

    render() {
        return (
            <span style={{cursor:"pointer" ,opacity:this.state.mergeDown ? "1":"0.3"}}>
                <img className={"editor-merge-down-tool-btn"} src={mergeDown}
                     onClick={()=>this.props.editor.execCommand("mergedown")}/>
                {this.state.mergeDown ? <style>{`
                .editor-merge-down-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-merge-down-tool-btn:hover{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.hover}
                }
                .editor-merge-down-tool-btn:active{
                    border: 1px solid ${EDITOR_TOOL_BTN_COLOR.press}
                }
            `}</style> : <style>{`
                .editor-merge-down-tool-btn{
                    border: 1px solid #f2f6fc
                }
                .editor-merge-down-tool-btn:hover{
                    border: 1px solid transparent
                }
                .editor-merge-down-tool-btn:active{
                    border: 1px solid transparent
                }
            `}</style>}

            </span>
        )
    }

}